<h1
  class="modal-header"
  style="background-color: var(--azul-bimbo); color: var(--blanco-bimbo)">
  Confirmación
</h1>

<div class="p-3 mt-0">
  <h4>{{ mensaje }}</h4>
  <div class="row" *ngIf="!flagEncontrado">
    <div class="form-floating">
      <input
        id="confirm-value"
        class="form-control"
        [(ngModel)]="inputValue"
        placeholder="*Vuelve a ingresar el valor para confirmar" />
      <label for="confirm-value"
        >*Vuelve a ingresar el valor para confirmar</label
      >
    </div>
  </div>
  <div class="d-flex justify-content-center align-content-center mb-2 mt-3">
    <div class="col-3 p-1">
      <button
        class="btn btn-primario"
        [disabled]="!isInputValueValid()"
        (click)="confirm()"
        *ngIf="!flagEncontrado">
        <span> Confirmar </span>
      </button>
      <button
        class="btn btn-primario"
        (click)="confirm()"
        *ngIf="flagEncontrado">
        <span> Confirmar </span>
      </button>
    </div>
    <div class="col-3 mx-1 p-1">
      <button class="btn btn-secondary-cap" (click)="cancel()">
        <span> Cancelar </span>
      </button>
    </div>
  </div>
</div>
